// useRoomNames — shared room number → display-name resolver.
//
// Rooms can be created with a plain number (e.g. 101) or a name (e.g. "Maharaja
// Room", stored in Roommasters.RoomName with an auto-assigned number). This hook
// loads the room master once and gives a `roomLabel(roomNumber)` helper that
// returns the NAME when one exists, otherwise the number itself — so every
// screen can show "name if entered, else number" consistently.
import { useEffect, useState, useCallback } from 'react';
import config from '../../config';

export function useRoomNames() {
  const [map, setMap] = useState({});

  useEffect(() => {
    const company = JSON.parse(
      sessionStorage.getItem('companyDetails') || '{}',
    );
    const token = sessionStorage.getItem('token');
    if (!company?.id) return;
    fetch(`${config.API_BASE_URL}/Home/GetAllRoom/${company.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((d) => {
        const m = {};
        (Array.isArray(d) ? d : []).forEach((r) => {
          if (r && r.roomName && r.roomnumber != null)
            m[String(r.roomnumber)] = r.roomName;
        });
        setMap(m);
      })
      .catch(() => {});
  }, []);

  // Returns the name if this room has one, else the original value (number).
  const roomLabel = useCallback(
    (roomNumber) => {
      if (roomNumber == null || roomNumber === '') return roomNumber;
      return map[String(roomNumber)] || roomNumber;
    },
    [map],
  );

  return { roomLabel, roomNameMap: map };
}
